// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"fcbad321","950":"a1e12268"}[chunkId] + ".chunk.js";
};